<script lang="ts" setup></script>
<template>
    <button class="sy-grid-button button clear">
        <Icon icon="chevron-right" class="sy-type-gray-dark"></Icon>
    </button>
</template>

<style lang="scss" scoped>
.sy-grid-button {
    padding: 0.3rem;
}
</style>
